import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@material-ui/styles';
import { createTheme } from '@material-ui/core';
import { themeModeSelector } from './redux/features/theme/themeSlice';
import { darkPalette, lightPalette } from './theme/palette';
import typography from './theme/typography';
import overrides from './theme/overrides';

const ThemedApp = ({ children }) => {
  const themeMode = useSelector(themeModeSelector);

  const theme = useMemo(() => {
    return createTheme({
      palette: themeMode === 'dark' ? darkPalette : lightPalette,
      typography,
      overrides,
      zIndex: {
        appBar: 1200,
        drawer: 1100
      }
    });
  }, [themeMode]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default ThemedApp;

